export default {
  en: {
    TeamCreateScene: {
      title: 'Create new user',
    },
  },
};
